<template>
    <div>
        <my-search @search="searchHandler" v-model="pgData" title-placeholder="标段名称/标段编号">
            <el-form-item slot="time"></el-form-item>
            <template slot="btn">
                <el-button type="success" icon="el-icon-plus" @click="addHandler">增加标段(包)</el-button>
                <el-button type="primary" icon="el-icon-time" @click="arrange" v-if="!!initialization.model && initialization.model.ext5=='J13013101'">预约开评标室</el-button>
            </template>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="标段名称" prop="bdname" sortable min-width="160" fixed="left"></el-table-column>
            <el-table-column label="标段编码" prop="bdcode" sortable min-width="160"></el-table-column>
            <el-table-column label="标段分类" prop="bdtypename" sortable width="200"></el-table-column>
            <el-table-column label="标段投资概算（万元人民币）" sortable width="240">
                <template slot-scope="scope">
                    {{scope.row.bdhtgsj}}{{scope.row.jedwname}}{{scope.row.bztext}}
                </template>
            </el-table-column>
            <el-table-column label="交易中心" width="240">
                <template slot-scope="scope">
                    <jyzx-state :data="scope.row"></jyzx-state>
                    
                    <push-type 
                        :column="scope.row" 
                        :pushPage="'zbbd'" 
                        :primaryKey="scope.row.bdcode"
                        :procode="getQuery('procode')">
                    </push-type>
                
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                    <btn-list 
                        :row="scope.row"
                        @reload="reloadHandler"
                        @edit="editClick(scope.row,'0')"
                        @detail="detailClick(scope.row)"
                        @copy="editClick(scope.row,'1')"
                        :config="BTN_CONF">
                    </btn-list>
                    <template v-if="initialization.ishd">
                        <template v-if="initialization.iszgys">
                            <el-button 
                                type="text" 
                                @click="extEdit(scope.row.bdcode)"
                                icon="el-icon-collection">
                                    完善预审场地信息
                            </el-button>
                            <el-button 
                                type="text" 
                                v-if="scope.row.by4!=null"
                                @click="extEdit(scope.row.by4)"
                                icon="el-icon-collection">
                                    完善正式场地信息
                            </el-button>
                        </template>
                        <template v-else>
                            <el-button 
                                type="text" 
                                @click="extEdit(scope.row.bdcode)"
                                icon="el-icon-collection">
                                    完善场地信息
                            </el-button>
                        </template>
                    </template>
                    
                </template>
            </el-table-column>
        </my-table>
        <my-pagination 
            ref="page" 
            v-model="tableData" 
            :search="pgData"
            :action="`${getGetters('mngUrl')}/revision/FangAn/BiaoDuan/get_list.json`">
        </my-pagination>

    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

import JyzxState from '@views/bidding/components/jyzx-state'
import BTN_CONF from './config/btn-list'
import PushType from '@/components-sys/push-type'

export default {
    mixins: [LIST_PAGE_MIXIN],
    components: {
        PushType,JyzxState
    },
    data() {
        return{
            pgData:{
                procode:this.getQuery('procode'),
                sortname:'bdcode'
            },
            isZc:false,
            initialization:{},
            BTN_CONF,
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        // 添加
        addHandler(){
    
            this.goto({
                path: '/bidding/projectflow/fangan/biaoduan/form',
                query: {
                    procode: this.getQuery('procode'),
                    isZc:this.isZc
                }
            });
        },
        // 修改
        editClick(row,val){
  
            this.goto({
                path: '/bidding/projectflow/fangan/biaoduan/form',
                query: {
                    procode: this.getQuery('procode'),
                    id: row.bdcode,
                    isZc:this.isZc,
                    copy:val
                }
            });
         
        },
        // 详情
        detailClick(row){
            this.goto({
                path: '/bidding/projectflow/fangan/biaoduan/detail',
                query: {
                    id: row.bdcode,
                    isZc:this.isZc
                }
            });
         
        },
        // 完善场地信息
        extEdit(bdcode){
            this.goto({
                path: '/bidding/projectflow/fangan/biaoduan/extEdit',
                query: {
                    procode: this.initialization.procode,
                    bdcode:bdcode
                }
            });
        },
        // 平山预约开评标室
        arrange(){
            this.goto({
                path: '/bidding/projectflow/fangan/kproom/list',
                query: {
                    zbprocode: this.initialization.procode,
                }
            });
        }
        
    },
    created() {
       var that = this   
        that.jspInit(`${that.getGetters('ageUrl')}/revision/FangAn/BiaoDuan/queryListPageData.json`, {
            procode:that.getQuery('procode')
        }, data => {
            that.initialization = data
            if(that.initialization.model.ext3){
                that.isZc = true
            }else{
                that.isZc = false
            }
        });
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">
    .limitTetx{}
</style>
